import React, { useContext } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useMediaQuery from "@mui/material/useMediaQuery";
import { AccountContext } from "../../context/AccountContext";
import SearchBar from "../Common/SearchBar";
import "./Header.css";

export default function Header(props) {
  const { applicationImagePath, brandName } = useContext(AccountContext);
  const isMobile = useMediaQuery("(max-width:900px)");

  if (isMobile) {
    return (
      <Row className="app-header no-padding">
        {/* Burger menu button - first item */}
        <Col xs="auto" className="mobile-burger-container">
          <button 
            className="mobile-burger-button"
            onClick={props.onBurgerClick}
            aria-label="Open menu"
          >
            <div className="burger-line"></div>
            <div className="burger-line"></div>
            <div className="burger-line"></div>
          </button>
        </Col>
        
        {/* Search bar - middle item */}
        <Col xs className="searchbar-container">
          <SearchBar />
        </Col>
        
        {/* Logo/emblem - last item */}
        <Col xs="auto" className="app-header-image">
          <a href="/" activeclassname="active">
            <img
              src={applicationImagePath}
              alt={brandName}
              className="app-header-image-class"
            />
          </a>
        </Col>
      </Row>
    );
  }

  return (
    <Row className="app-header no-padding">
      <Col xs="auto" className="app-header-image">
        <a href="/" activeclassname="active">
          <img
            src={applicationImagePath}
            alt={brandName}
            className="app-header-image-class"
          />
        </a>
      </Col>
      
      <Col xs className="searchbar-container">
        <SearchBar />
      </Col>
    </Row>
  );
}
